import { render, staticRenderFns } from "./PdfReconstructedChapter.vue?vue&type=template&id=15cb6f26&scoped=true"
import script from "./PdfReconstructedChapter.vue?vue&type=script&lang=js"
export * from "./PdfReconstructedChapter.vue?vue&type=script&lang=js"
import style0 from "./PdfReconstructedChapter.vue?vue&type=style&index=0&id=15cb6f26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cb6f26",
  null
  
)

export default component.exports